import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import { TimelineActions } from '../../store';
import { ApplicationState } from '../../store/types';
import Presets, { PresetsActions, PresetsProps } from './Presets';

export const mapStateToProps: MapStateToProps<PresetsProps, any, ApplicationState> = (state, _) => {
  return {
    preset: state.timeline.preset
  };
};

export const mapDispatchToProps: MapDispatchToProps<PresetsActions, any> = (dispatch: Dispatch, _) => {
  const { setPreset, setRangeAndViewMode } = TimelineActions;
  return {
    setPreset: preset => dispatch(setPreset(preset)),
    setRangeAndViewMode: (startDate, endDate, viewModeType) =>
      dispatch(setRangeAndViewMode(startDate, endDate, viewModeType))
  };
};

export const PresetsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Presets);



// WEBPACK FOOTER //
// ./src/components/navbar/PresetsContainer.ts